// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

import { WarmUpFailureCard } from "../components/common/warmUp/WarmUpFailureCard";
import { WORKSPACE_FAILURE_COPY } from "../components/common/warmUp/warmUpCopy";
import type { WarmUpFailure } from "../services/api/coldStartRetry";
import { FullPageFrame } from "./FullPageLoader";

export function WorkspaceLoadErrorScreen({
  failure,
  onRetry,
}: {
  failure: WarmUpFailure;
  onRetry: () => void;
}) {
  return (
    <FullPageFrame>
      <WarmUpFailureCard copy={WORKSPACE_FAILURE_COPY} failure={failure} onRetry={onRetry} />
    </FullPageFrame>
  );
}
